module.exports = __webpack_public_path__ + "static/media/phone.c655f90.mp4";


//////////////////
// WEBPACK FOOTER
// ./src/assets/videoBg/Magazine/phone.mp4
// module id = s8Sh
// module chunks = 1